import { computed } from 'vue'
import { useStore } from 'vuex'

export function useKybGuard() {
  const store = useStore()

  const isKybApproved = computed(() => store.getters['account/isKybApproved'])

  function ensureKyb() {
    if (isKybApproved.value) return true
    store.dispatch('ui/showProductActivationModal', 'kyb')
    return false
  }

  function withKybCheck(fn) {
    return async (...args) => {
      if (!ensureKyb()) return
      return fn(...args)
    }
  }

  return {
    isKybApproved,
    ensureKyb,
    withKybCheck,
  }
}
